import * as Yup from 'yup';
import {useTranslation} from 'react-i18next';

interface UseTrialFormValidationProps {
    contactType: 'phone' | 'email';
    maxContacts?: number;
    namespace?: string;
}

export const useTrialFormValidation = ({contactType, maxContacts = 3, namespace = 'mailing'}: UseTrialFormValidationProps) => {
    const {t} = useTranslation(namespace);

    const getValidationSchema = () => {
        const baseValidation = Yup.array()
            .min(1, t('atLeastOneContact'))
            .max(maxContacts, t('maxContactsReached'))
            .test('at-least-one-valid', t('atLeastOneValidContact'), function(value) {
                return value && value.some(contact => contact?.trim() !== '');
            });

        if(contactType === 'email') {
            return Yup.object().shape({
                contacts: baseValidation.of(
                    Yup.string().email()
                )
            });
        } else {
            return Yup.object().shape({
                contacts: baseValidation.of(
                    Yup.string()
                        .matches(/^[0-9+\-\s()]+$/, t('invalidPhoneFormat'))
                        .min(10, t('phoneTooShort'))
                        .max(15, t('phoneTooLong'))
                ),
            });
        }
    };

    const validationSchema = getValidationSchema();

    return {
        validationSchema
    };
};
